import BookmakerUrlModel from "../Bookmakers/BookmakerUrlModel";
import SelectionProviderInfoModel from "./SelectionProviderInfoModel";

export default class MatchOddsMarketSelectionModel {
  public id: string = null;
  public name: string = null;
  public code: string = null;
  public value: string = null;
  public odds: string = null;
  public urls: BookmakerUrlModel[] = [];
  public movement: string = null;
  public oddsOld: string = null;
  public entityType: string = null;
  public additionalInfo: any = null;
  public providerInfo: SelectionProviderInfoModel | null = null;
}
